export { default as Aggregations } from './Aggregations';
export { default as DataSources } from './DataSources';
export * as Devices from './Devices';
export * as MetricIds from './MetricIds';
export { default as SpanIds } from './SpanIds';
export * as UnitChoices from './UnitChoices';
export var AlertType;
(function (AlertType) {
    AlertType[AlertType["highTemperatureOnSingleMeasurement"] = 1000] = "highTemperatureOnSingleMeasurement";
    AlertType[AlertType["lowTemperatureOnSingleMeasurement"] = 1001] = "lowTemperatureOnSingleMeasurement";
    AlertType[AlertType["highRainfallsOnSingleMeasurement"] = 1002] = "highRainfallsOnSingleMeasurement";
    AlertType[AlertType["highHumidityOnSingleMeasurement"] = 1004] = "highHumidityOnSingleMeasurement";
    AlertType[AlertType["lowHumidityOnSingleMeasurement"] = 1005] = "lowHumidityOnSingleMeasurement";
    AlertType[AlertType["highWindOnSingleMeasurement"] = 1006] = "highWindOnSingleMeasurement";
    AlertType[AlertType["lowWindOnSingleMeasurement"] = 1007] = "lowWindOnSingleMeasurement";
    AlertType[AlertType["highGustWindOnSingleMeasurement"] = 1008] = "highGustWindOnSingleMeasurement";
    AlertType[AlertType["lowGustWindOnSingleMeasurement"] = 1009] = "lowGustWindOnSingleMeasurement";
    AlertType[AlertType["highDryTemperatureOnSingleMeasurement"] = 1010] = "highDryTemperatureOnSingleMeasurement";
    AlertType[AlertType["lowDryTemperatureOnSingleMeasurement"] = 1011] = "lowDryTemperatureOnSingleMeasurement";
    AlertType[AlertType["highWetTemperatureOnSingleMeasurement"] = 1012] = "highWetTemperatureOnSingleMeasurement";
    AlertType[AlertType["lowWetTemperatureOnSingleMeasurement"] = 1013] = "lowWetTemperatureOnSingleMeasurement";
    AlertType[AlertType["highTemperatureOnCumul"] = 1100] = "highTemperatureOnCumul";
    AlertType[AlertType["highRainfallsOnCumul"] = 1102] = "highRainfallsOnCumul";
    AlertType[AlertType["rainBeginningAndEndOnCumul"] = 1104] = "rainBeginningAndEndOnCumul";
    AlertType[AlertType["rainfallsOnForecasts"] = 1200] = "rainfallsOnForecasts";
    AlertType[AlertType["observedHydricPotentialState"] = 1301] = "observedHydricPotentialState";
    AlertType[AlertType["observedSoilMoistureStateCapa"] = 1302] = "observedSoilMoistureStateCapa";
})(AlertType || (AlertType = {}));
export var OrgRole;
(function (OrgRole) {
    OrgRole[OrgRole["owner"] = 0] = "owner";
    OrgRole[OrgRole["admin"] = 1] = "admin";
    OrgRole[OrgRole["agent"] = 3] = "agent";
    OrgRole[OrgRole["viewer"] = 4] = "viewer";
    OrgRole[OrgRole["advisor"] = 5] = "advisor";
})(OrgRole || (OrgRole = {}));
export const allOrgRole = [
    OrgRole.owner,
    OrgRole.admin,
    OrgRole.agent,
    OrgRole.viewer,
    OrgRole.advisor
];
export var TemplateCropUsage;
(function (TemplateCropUsage) {
    TemplateCropUsage[TemplateCropUsage["production"] = 0] = "production";
    TemplateCropUsage[TemplateCropUsage["transitional"] = 1] = "transitional";
})(TemplateCropUsage || (TemplateCropUsage = {}));
/** @zod */
export var OptionCode;
(function (OptionCode) {
    OptionCode["abelio"] = "OAD-ABELIO";
    OptionCode["agrigenio"] = "OAD-AGRIGENIO";
    OptionCode["avizio"] = "OAD-AVIZIO";
    OptionCode["cropTracking"] = "OAD-CROPTRACKING";
    OptionCode["cumulativeSum"] = "OAD-CUMULATIVESUM";
    OptionCode["decitrait"] = "OAD-DECITRAIT";
    OptionCode["ftpExport"] = "OAD-FTP-EXPORT";
    OptionCode["grapeVision"] = "OAD-GRAPEVISION";
    /** API IOT */
    OptionCode["irrelis"] = "OAD-IRRELIS";
    OptionCode["maizy"] = "OAD-MAIZY";
    OptionCode["mileos"] = "OAD-MILEOS";
    OptionCode["movida"] = "OAD-MOVIDA";
    OptionCode["rimpro"] = "OAD-RIMPRO";
    OptionCode["semiloni"] = "OAD-SEMILONI";
    OptionCode["sms100"] = "PACK-SMS";
    OptionCode["tavmills"] = "OAD-TAVMILLS";
    OptionCode["tavplus"] = "OAD-TAVPLUS";
    OptionCode["vintel"] = "OAD-VINTEL";
    OptionCode["vitimeteo"] = "OAD-VITIMETEO";
    OptionCode["wago"] = "OAD-WAGO";
    /** Bilan Hydrique */
    OptionCode["waterBalance"] = "OAD-BH";
    /** Irré-Lis by Arvalis mono-culture */
    OptionCode["waterBalanceArvalisMono"] = "OAD-BH-ARVALIS-MONO";
    /** Irré-Lis by Arvalis multi-culture */
    OptionCode["waterBalanceArvalisMulti"] = "OAD-BH-ARVALIS-MULTI";
    /** Bilan Hydrique Recherche Innovation */
    OptionCode["waterBalanceRI"] = "OAD-BH-RI";
    OptionCode["weatherMeasure"] = "OPT-WM";
    OptionCode["weedriq"] = "OAD-WEEDRIQ";
    OptionCode["weephyt"] = "OAD-WEEPHYT";
    OptionCode["xarvio"] = "OAD-XARVIO";
    OptionCode["xarvioLegacy"] = "OAD-ATLAS";
})(OptionCode || (OptionCode = {}));
/** @zod */
export var BillingStatus;
(function (BillingStatus) {
    BillingStatus[BillingStatus["essential"] = 1] = "essential";
    BillingStatus[BillingStatus["plus"] = 0] = "plus";
    BillingStatus[BillingStatus["expert"] = 3] = "expert";
})(BillingStatus || (BillingStatus = {}));
export var NetworkType;
(function (NetworkType) {
    NetworkType[NetworkType["community"] = 0] = "community";
    NetworkType[NetworkType["distribution"] = 1] = "distribution";
    NetworkType[NetworkType["exclusiveDistribution"] = 2] = "exclusiveDistribution";
})(NetworkType || (NetworkType = {}));
export var OrgCrop;
(function (OrgCrop) {
    OrgCrop[OrgCrop["cereal"] = 0] = "cereal";
    OrgCrop[OrgCrop["potato"] = 1] = "potato";
    OrgCrop[OrgCrop["cropLivestockFarming"] = 2] = "cropLivestockFarming";
    OrgCrop[OrgCrop["viticulture"] = 3] = "viticulture";
    OrgCrop[OrgCrop["arboriculture"] = 4] = "arboriculture";
    OrgCrop[OrgCrop["marketGardening"] = 5] = "marketGardening";
})(OrgCrop || (OrgCrop = {}));
export var InvitationStatus;
(function (InvitationStatus) {
    InvitationStatus[InvitationStatus["pending"] = 0] = "pending";
    InvitationStatus[InvitationStatus["accepted"] = 1] = "accepted";
    InvitationStatus[InvitationStatus["declined"] = 2] = "declined";
    InvitationStatus[InvitationStatus["duplicated"] = 3] = "duplicated";
    InvitationStatus[InvitationStatus["invalid"] = 4] = "invalid";
    InvitationStatus[InvitationStatus["cancel"] = 6] = "cancel";
})(InvitationStatus || (InvitationStatus = {}));
export var WeatherProvider;
(function (WeatherProvider) {
    // TODO: remove
    WeatherProvider[WeatherProvider["theWeatherCompany"] = 0] = "theWeatherCompany";
    WeatherProvider[WeatherProvider["weatherMeasure"] = 2] = "weatherMeasure";
})(WeatherProvider || (WeatherProvider = {}));
export var WeatherModelID;
(function (WeatherModelID) {
    WeatherModelID[WeatherModelID["AROME"] = 0] = "AROME";
    WeatherModelID[WeatherModelID["ARPEGE"] = 1] = "ARPEGE";
    WeatherModelID[WeatherModelID["ICON_D2"] = 2] = "ICON_D2";
    WeatherModelID[WeatherModelID["ICON_EU"] = 3] = "ICON_EU";
    WeatherModelID[WeatherModelID["ICON_WORLD"] = 4] = "ICON_WORLD";
    WeatherModelID[WeatherModelID["GFS"] = 5] = "GFS";
})(WeatherModelID || (WeatherModelID = {}));
